import { createSlice, createAsyncThunk, AsyncThunk } from "@reduxjs/toolkit";
import { filterTableDataAPI } from "services/CRUDServices";
import { filterUrls } from "services/api.enums";

export const filterCredit: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "allocatecredit",
  async (body: any) => {

    const data = await filterTableDataAPI(
      filterUrls.gridFromCredit,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    );

    return data.data;
  }
);

const initialState: any = {
  creditData: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
};

const CreditSlice = createSlice({
  initialState: initialState,
  name: "allocatecredit",
  reducers: {
    clearCredit: (state) => {
      state.creditData = [];
    },
    setFilterCredit: (state, action) => {
      state.filter = action.payload;
    },
  },
  extraReducers: {
    [filterCredit.fulfilled as any]: (state, action) => {
      state.creditData = action.payload.payload;
      state.fetchPost = false;
    },
    [filterCredit.pending as any]: (state) => {
      state.fetchPost = true;
    },
    [filterCredit.rejected as any]: (state) => {
      state.fetchPost = false;
      state.errorMessage = "wrong";
    },
  },
});

export const { setFilterCredit, clearCredit } = CreditSlice.actions;
export default CreditSlice.reducer;
